export const hasTaxonomy = (item, elementCodename, taxonomyCodename) =>
  item?.elements?.[elementCodename]?.value?.some((t) => t.codename === taxonomyCodename);

export const findByTaxonomyCodename = (items, taxonomyKey, codename) =>
  items?.find((item) => item.elements?.[taxonomyKey]?.value?.some((t) => t.codename === codename));
